import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DateValue } from 'components/Filters/Date'
import { AppState } from 'store'
import { LeadReportFilters } from './types'

type State = {
  activeFilters: Array<LeadReportFilters.FilterNames>
  leadInDate: DateValue['option']
  view: 'daily'
  viewInPercentage: boolean
  leadProcessId?: string
  // leadType: PopOverItem<undefined>[]
  // leadSource: DateValue
  // leadCampaign: DateValue
  // leadCampaign: DateValue
}

export const initialState: State = {
  activeFilters: ['leadInDate'],
  leadInDate: 'this_month',
  view: 'daily',
  viewInPercentage: true,
  leadProcessId: undefined,
  // leadType: false,
  // leadSource: false,
  // leadCampaign: false,
}

const slice = createSlice({
  name: 'report-leadReport',
  initialState,
  reducers: {
    changedActiveFilters(draft, { payload: activeFilters }: PayloadAction<State['activeFilters']>) {
      draft.activeFilters = activeFilters
    },
    changedLeadInDate(draft, { payload: leadInDate }: PayloadAction<State['leadInDate']>) {
      draft.leadInDate = leadInDate
    },
    changedViewInPercentage(draft, { payload: viewInPercentage }: PayloadAction<State['viewInPercentage']>) {
      draft.viewInPercentage = viewInPercentage
    },
    changedView(draft, { payload: view }: PayloadAction<State['view']>) {
      draft.view = view
    },
    loadedLeadProcess(draft, { payload: leadProcessId }: PayloadAction<State['leadProcessId']>) {
      draft.leadProcessId = leadProcessId
    },
    changedLeadProcess(draft, { payload: leadProcessId }: PayloadAction<State['leadProcessId']>) {
      draft.leadProcessId = leadProcessId
    },
    clickedResetButton(draft) {
      draft.activeFilters = initialState.activeFilters
      draft.leadInDate = initialState.leadInDate
      draft.viewInPercentage = initialState.viewInPercentage
    },
  },
})

export const {
  changedActiveFilters,
  changedLeadInDate,
  changedViewInPercentage,
  changedView,
  loadedLeadProcess,
  changedLeadProcess,
  clickedResetButton,
} = slice.actions

export default slice.reducer

const getState = (state: AppState) => state.report.leadReport

export const getLeadReportFilters = (state: AppState) => getState(state)
